import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import loadContent from "core-module/hoc/loadContent";

// core components
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

//import SweetAlert from "react-bootstrap-sweetalert";
import Button from "common/components/CustomButtons/Button.jsx";

// @material-ui/icons
import Phone from "@material-ui/icons/Phone";
import Check from "@material-ui/icons/Check";

// core components
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

const style = {
  ...regularFormsStyle,
  ...dashboardStyle,
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px"
  },
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  }
};

const DnList = props => {
  const { classes } = props;
  return (
    <div>
      {props.getList((oGet, id) => (
        <div key={"checkbox" + id} className={classes.checkboxAndRadio}>
          <FormControlLabel
            control={
              <Checkbox
                tabIndex={-1}
                checked={props.getChecked(id)}
                onClick={() => props.toggleChecked(id)}
                checkedIcon={<Check className={classes.checkedIcon} />}
                icon={<Check className={classes.uncheckedIcon} />}
                classes={{
                  checked: classes.checked,
                  root: classes.checkRoot
                }}
              />
            }
            classes={{
              label: classes.label
            }}
            label={props.getDn(id)}
          />
        </div>
      ))}
    </div>
  );
};

const DnListWithStyle = withStyles(style)(DnList);

class Step1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
  }

  componentDidMount() {
    let newState = { ...this.state };

    this.props.getList((oGet, id) => {
      let checked = false;
      const dn = oGet("dn");

      for (let usedDN of this.props.associatedDnList) {
        if (dn === usedDN) {
          checked = true;
        }
      }

      newState[id] = checked;
      newState[id + "dn"] = dn;
    });
    newState.loading = false;
    this.setState(newState);
  }

  onSubmit = () => {
    let dnBPSarray = [];

    this.props.getList((oGet, id) => {
      if (this.state[id]) {
        dnBPSarray.push(id);
      }
    });

    this.props.onSubmitDnChange(this.props.ids.billingpackage, dnBPSarray);
  };

  render() {
    if (this.state.loading) {
      return null;
    }
    return (
      <GridContainer justify="center">
        <GridItem xs={12}>
          <DnListWithStyle
            getList={this.props.getList}
            getChecked={id => this.state[id]}
            getDn={id => this.state[id + "dn"]}
            toggleChecked={id =>
              this.setState(prevState => ({ [id]: !prevState[id] }))
            }
          />
        </GridItem>
        <GridItem xs={12} sm={6}>
          <Button
            fullWidth
            color="primaryRed"
            onClick={this.props.onCancelButton}
          >
            Cancel
          </Button>
        </GridItem>
        <GridItem xs={12} sm={6}>
          <Button fullWidth color="primaryLightBlue" onClick={this.onSubmit}>
            Submit
          </Button>
        </GridItem>
      </GridContainer>
    );
  }
}

const WizardStep1 = withStyles(style)(
  loadContent("user.session/billingpackage.props/directorynumber", Step1)
);

const SelectDnWizard = props => {
  const { classes } = props;
  return (
    <GridContainer justify="center">
      <GridItem xs={12} md={8}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Phone />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              Emergency Profile Associate Phone Number
            </h4>
          </CardHeader>
          <CardBody>
            <WizardStep1
              associatedDnList={props.associatedDnList}
              pathids={props.pathids}
              onCancelButton={props.closeWizard}
              onSubmitDnChange={props.onFinishDnWizard}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(style)(SelectDnWizard);
